import { useNode } from '@craftjs/core';
import { useFormContext } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { FormNumberInputComponent } from 'src/features/generalForms/builder/types/NumberInput';
import { HookFormTextField } from 'src/features/generalForms/uikit/hookFormFields/hookFormTextField';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';

export const FormNumberInput: FormNumberInputComponent = (props) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);

  if (!visible) {
    return <></>;
  }

  return (
    <div style={{ ...styles, boxSizing: 'border-box' }}>
      <HookFormTextField
        control={form.control}
        name={props.dataKey!}
        maxLength={props.maxLength}
        type={'number'}
        disabled={isDisabled}
        placeholder={props.placeholder}
        units={props.units}
        decimal={props.decimal}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        rules={hookFormRules({
          required: !props.isOptional && !isDisabled,
          pattern: props.pattern,
          max: props.maxValue,
          min: props.minValue,
        })}
        errorProps={{ errors }}
        defaultValue={props.defaultValue}
      />
    </div>
  );
};
